export enum IntensiteColmatage {
    Nul,
    Faible,
    Fort
}
